export class ScormEntry {
  id: number;
  scormSessionId: number;
  elementName: string;
  elementValue: string;
  dateCreated: Date;
  dateModified: Date;
  learnerCourseLogId: number;
}

/* {
  "id": 0,
  "scormSessionId": 0,
  "elementName": "string",
  "elementValue": "string",
  "dateCreated": "2021-11-02T09:15:33.017Z",
  "dateModified": "2021-11-02T09:15:33.017Z"
} */
